export default "__VITE_ASSET__DuCoS3v9__"